export const generateLatestMeetingUrl = (parameters: {
  meetingTypes: string[];
  authors: string[];
  animators: string[];
  programs: string[];
  showUnassigned: boolean;
  showDetailedSearch: boolean;
  searchQuery: string;
  createdAfter?: string | null;
  createdBefore?: string | null;
}): string => {
  const filters = [];

  if (parameters.createdAfter) {
    filters.push(`created_after=${parameters.createdAfter}`);
  }

  if (parameters.createdBefore) {
    filters.push(`created_before=${parameters.createdBefore}`);
  }

  if (parameters.meetingTypes.length > 0) filters.push(`type_ids=${parameters.meetingTypes.join(",")}`);
  if (parameters.authors.length > 0) filters.push(`author_ids=${parameters.authors.filter(Boolean).join(",")}`);
  if (parameters.animators.length > 0) filters.push(`animator_ids=${parameters.animators.filter(Boolean).join(",")}`);
  if (parameters.programs && parameters.programs.length > 0)
    filters.push(`program=${parameters.programs.filter(Boolean).join(",")}`);
  if (parameters.showUnassigned) filters.push("show_unassigned=true");
  if (parameters.showDetailedSearch) filters.push("get_campus_names=true");
  if (parameters.searchQuery) filters.push(`search=${parameters.searchQuery.toLowerCase()}`);

  return `meetings?get_animators_info=true&get_authors_info=true&get_meeting_type_info=true&fetch_users_count=true&get_campus_names=true${
    filters.length > 0 ? `&${filters.join("&")}` : ""
  }`;
};
